import React from 'react'
import Popover from '@mui/material/Popover'
import { ListItem, List, ListItemText, Button } from '@mui/material'
import {
  ISchool,
  ISchoolAdditionalLinks,
} from '../../interfaces/school.interface'
import Link from 'next/link'
import ArrowDownIcon from '@mui/icons-material/ArrowDropDown'

export default function SchoolAdditionalLinkPopoverComponent(props: {
  customStyle?: any
  schoolDetails: ISchool
  additionalLinks?: ISchoolAdditionalLinks[]
}) {
  const customStyle = props.customStyle
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const [additionalLinks] = React.useState<ISchoolAdditionalLinks[]>(
    generateLinks(),
  )

  function generateLinks(): ISchoolAdditionalLinks[] {
    let links = props.schoolDetails?.additional_links || []
    if (props.additionalLinks) {
      links = links.concat(props.additionalLinks)
    }
    return links
  }

  function handleClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined
  console.log(props.schoolDetails?.additional_links)

  if (!props.schoolDetails?.additional_links?.length) {
    return <span />
  }

  return (
    <div>
      <Button color={'primary'} aria-describedby={id} onClick={handleClick}>
        Links <ArrowDownIcon style={customStyle || {}} />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <List dense={true}>
          {additionalLinks?.map((c: any, index: number) => {
            if (!c) {
              return <div key={index} />
            }
            return (
              <ListItem
                style={{
                  width: '200px',
                }}
                component={Link}
                href={c.link || ''}
                button={true}
              >
                <ListItemText>{c?.title || ''}</ListItemText>
              </ListItem>
            )
          })}
        </List>
      </Popover>
    </div>
  )
}
